module.exports = __webpack_public_path__ + "img/avator.3f9e62af.png";